export const countries = [
	{ iso: 'af', code: '+93', name: 'Afghanistan' },
	{ iso: 'al', code: '+355', name: 'Albania' },
	{ iso: 'dz', code: '+213', name: 'Algeria' },
	{ iso: 'ad', code: '+376', name: 'Andorra' },
	{ iso: 'ao', code: '+244', name: 'Angola' },
	{ iso: 'ai', code: '+1 264', name: 'Anguilla' },
	{ iso: 'ar', code: '+54', name: 'Argentina' },
	{ iso: 'am', code: '+374', name: 'Armenia' },
	{ iso: 'au', code: '+61', name: 'Australia' },
	{ iso: 'at', code: '+43', name: 'Austria' },
	{ iso: 'az', code: '+994', name: 'Azerbaijan' },
	{ iso: 'bs', code: '+1 242', name: 'Bahamas' },
	{ iso: 'bh', code: '+973', name: 'Bahrain' },
	{ iso: 'bd', code: '+880', name: 'Bangladesh' },
	{ iso: 'bb', code: '+1 246', name: 'Barbados' },
	{ iso: 'by', code: '+375', name: 'Belarus' },
	{ iso: 'be', code: '+32', name: 'Belgium' },
	{ iso: 'bz', code: '+501', name: 'Belize' },
	{ iso: 'bj', code: '+229', name: 'Benin' },
	{ iso: 'bm', code: '+1 441', name: 'Bermuda' },
	{ iso: 'bt', code: '+975', name: 'Bhutan' },
	{ iso: 'bo', code: '+591', name: 'Bolivia' },
	{ iso: 'ba', code: '+387', name: 'Bosnia and Herzegovina' },
	{ iso: 'bw', code: '+267', name: 'Botswana' },
	{ iso: 'br', code: '+55', name: 'Brazil' },
	{ iso: 'bn', code: '+673', name: 'Brunei' },
	{ iso: 'bg', code: '+359', name: 'Bulgaria' },
	{ iso: 'bf', code: '+226', name: 'Burkina Faso' },
	{ iso: 'bi', code: '+257', name: 'Burundi' },
	{ iso: 'kh', code: '+855', name: 'Cambodia' },
	{ iso: 'cm', code: '+237', name: 'Cameroon' },
	{ iso: 'ca', code: '+1', name: 'Canada' },
	{ iso: 'cv', code: '+238', name: 'Cape Verde' },
	{ iso: 'ky', code: '+1 345', name: 'Cayman Islands' },
	{ iso: 'cf', code: '+236', name: 'Central African Republic' },
	{ iso: 'td', code: '+235', name: 'Chad' },
	{ iso: 'cl', code: '+56', name: 'Chile' },
	{ iso: 'cn', code: '+86', name: 'China' },
	{ iso: 'co', code: '+57', name: 'Colombia' },
	{ iso: 'km', code: '+269', name: 'Comoros' },
	{ iso: 'cg', code: '+242', name: 'Congo' },
	{ iso: 'cr', code: '+506', name: 'Costa Rica' },
	{ iso: 'hr', code: '+385', name: 'Croatia' },
	{ iso: 'cu', code: '+53', name: 'Cuba' },
	{ iso: 'cy', code: '+357', name: 'Cyprus' },
	{ iso: 'cz', code: '+420', name: 'Czech Republic' },
	{ iso: 'dk', code: '+45', name: 'Denmark' },
	{ iso: 'dj', code: '+253', name: 'Djibouti' },
	{ iso: 'do', code: '+1 809', name: 'Dominican Republic' },
	{ iso: 'ec', code: '+593', name: 'Ecuador' },
	{ iso: 'eg', code: '+20', name: 'Egypt' },
	{ iso: 'sv', code: '+503', name: 'El Salvador' },
	{ iso: 'ee', code: '+372', name: 'Estonia' },
	{ iso: 'et', code: '+251', name: 'Ethiopia' },
	{ iso: 'fi', code: '+358', name: 'Finland' },
	{ iso: 'fr', code: '+33', name: 'France' },
	{ iso: 'ge', code: '+995', name: 'Georgia' },
	{ iso: 'de', code: '+49', name: 'Germany' },
	{ iso: 'gh', code: '+233', name: 'Ghana' },
	{ iso: 'gr', code: '+30', name: 'Greece' },
	{ iso: 'gp', code: '+590', name: 'Guadeloupe' },
	{ iso: 'gt', code: '+502', name: 'Guatemala' },
	{ iso: 'hn', code: '+504', name: 'Honduras' },
	{ iso: 'hk', code: '+852', name: 'Hong Kong' },
	{ iso: 'hu', code: '+36', name: 'Hungary' },
	{ iso: 'is', code: '+354', name: 'Iceland' },
	{ iso: 'in', code: '+91', name: 'India' },
	{ iso: 'id', code: '+62', name: 'Indonesia' },
	{ iso: 'ie', code: '+353', name: 'Ireland' },
	{ iso: 'il', code: '+972', name: 'Israel' },
	{ iso: 'it', code: '+39', name: 'Italy' },
	{ iso: 'jp', code: '+81', name: 'Japan' },
	{ iso: 'jo', code: '+962', name: 'Jordan' },
	{ iso: 'kz', code: '+7', name: 'Kazakhstan' },
	{ iso: 'ke', code: '+254', name: 'Kenya' },
	{ iso: 'kw', code: '+965', name: 'Kuwait' },
	{ iso: 'lv', code: '+371', name: 'Latvia' },
	{ iso: 'lb', code: '+961', name: 'Lebanon' },
	{ iso: 'lr', code: '+231', name: 'Liberia' },
	{ iso: 'li', code: '+423', name: 'Liechtenstein' },
	{ iso: 'lt', code: '+370', name: 'Lithuania' },
	{ iso: 'lu', code: '+352', name: 'Luxembourg' },
	{ iso: 'mk', code: '+389', name: 'North Macedonia' },
	{ iso: 'mg', code: '+261', name: 'Madagascar' },
	{ iso: 'mw', code: '+265', name: 'Malawi' },
	{ iso: 'my', code: '+60', name: 'Malaysia' },
	{ iso: 'mv', code: '+960', name: 'Maldives' },
	{ iso: 'mt', code: '+356', name: 'Malta' },
	{ iso: 'mr', code: '+222', name: 'Mauritania' },
	{ iso: 'mu', code: '+230', name: 'Mauritius' },
	{ iso: 'mx', code: '+52', name: 'Mexico' },
	{ iso: 'md', code: '+373', name: 'Moldova' },
	{ iso: 'ma', code: '+212', name: 'Morocco' },
	{ iso: 'np', code: '+977', name: 'Nepal' },
	{ iso: 'nl', code: '+31', name: 'Netherlands' },
	{ iso: 'nz', code: '+64', name: 'New Zealand' },
	{ iso: 'ng', code: '+234', name: 'Nigeria' },
	{ iso: 'no', code: '+47', name: 'Norway' },
	{ iso: 'pk', code: '+92', name: 'Pakistan' },
	{ iso: 'pa', code: '+507', name: 'Panama' },
	{ iso: 'pe', code: '+51', name: 'Peru' },
	{ iso: 'ph', code: '+63', name: 'Philippines' },
	{ iso: 'pl', code: '+48', name: 'Poland' },
	{ iso: 'pt', code: '+351', name: 'Portugal' },
	{ iso: 'ro', code: '+40', name: 'Romania' },
	{ iso: 'ru', code: '+7', name: 'Russia' },
	{ iso: 'sa', code: '+966', name: 'Saudi Arabia' },
	{ iso: 'rs', code: '+381', name: 'Serbia' },
	{ iso: 'sg', code: '+65', name: 'Singapore' },
	{ iso: 'sk', code: '+421', name: 'Slovakia' },
	{ iso: 'si', code: '+386', name: 'Slovenia' },
	{ iso: 'za', code: '+27', name: 'South Africa' },
	{ iso: 'kr', code: '+82', name: 'South Korea' },
	{ iso: 'es', code: '+34', name: 'Spain' },
	{ iso: 'se', code: '+46', name: 'Sweden' },
	{ iso: 'ch', code: '+41', name: 'Switzerland' },
	{ iso: 'tw', code: '+886', name: 'Taiwan' },
	{ iso: 'th', code: '+66', name: 'Thailand' },
	{ iso: 'tr', code: '+90', name: 'Turkey' },
	{ iso: 'ua', code: '+380', name: 'Ukraine' },
	{ iso: 'ae', code: '+971', name: 'United Arab Emirates' },
	{ iso: 'gb', code: '+44', name: 'United Kingdom' },
	{ iso: 'us', code: '+1', name: 'United States' },
	{ iso: 'uy', code: '+598', name: 'Uruguay' },
	{ iso: 've', code: '+58', name: 'Venezuela' },
	{ iso: 'vn', code: '+84', name: 'Vietnam' },
	{ iso: 'ye', code: '+967', name: 'Yemen' },
];
